module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/2-11af35abfedfbdad601e65e2bb03bfe3.jpg";